import { cx } from '@7f-ui';
import { Star } from '@phosphor-icons/react';
type StarsProps = {
  rating: number;
  className?: string;
  direction?: 'ltr' | 'rtl';
};
export function TrustedStars({
  rating,
  className,
  direction = 'ltr'
}: StarsProps) {
  return Array.from({
    length: 5
  }).map((_, i) => {
    const indexFromRight = 5 - i;
    return <Star key={i} weight="fill" className={cx('text-sand', {
      'text-ocker': direction === 'ltr' ? i < rating : indexFromRight <= rating
    }, className)} />;
  });
}